// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oYSNO","left":"styles_left__2QP8x"};